import React, { useEffect, useState } from 'react'
import Tab from '../../../../component/Tabs/Tab';
import { Link } from 'react-router-dom';

const Report = () => {

    const [activeType, setActiveType] = useState("bussines");
    const tabHeader = [
        {
            "key": "bussines",
            "label": "Sekilas Bisnis",
        },
        {
            "key": "sales",
            "label": "Penjualan",
        },
        {
            "key": "purchases",
            "label": "Pembelian",
        },
        // {
        //     "key": "product",
        //     "label": "Produk",
        // },
        // {
        //     "key": "asset",
        //     "label": "Aset",
        // },
        // {
        //     "key": "bank",
        //     "label": "Bank",
        // },
        {
            "key": "tax",
            "label": "Pajak",
        },
    ];

    const [tabContent, setTabContent] = useState([]);

    useEffect(() => {
        if (activeType == 'sales') {
            setTabContent([
                {
                    title: 'Daftar Penjualan',
                    description: 'Menampilkan transaksi penjualan secara kronologis berdasarkan tipenya dalam periode tertentu. Template laporan ini bisa Anda custom sesuai kebutuhan.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`/activity-erpppsu/report/sales`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Penjualan per pelanggan',
                    description: 'Menampilkan semua transaksi penjualan dari setiap pelanggan dalam periode tertentu.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`#`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Piutang Pelanggan',
                    description: 'Menampilkan semua faktur yang belum dibayar dan saldo memo kredit pelanggan pada tanggal tertentu.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`/activity-erpppsu/report/customer-balance`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Usia Piutang',
                    description: 'Menampilkan total piutang dari setiap pelanggan berdasarkan usianya (30, 60, 90, dan setelah 90 hari).',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`#`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Pengiriman Penjualan',
                    description: 'Menampilkan semua produk yang dikirim untuk transaksi penjualan dalam periode tertentu.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`#`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Penjualan per Produk',
                    description: 'Menampilkan semua kuantitas produk yang terjual, kuantitas retur, penjualan bersih, dan harga penjualan rata-rata dalam periode tertentu.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`#`}>
                        Lihat Laporan
                    </Link>
                },
                {
                    title: 'Penyelesaian Pesanan Penjualan',
                    description: 'Menampilkan ringkasan proses bisnis perusahaan ini. Anda dapat mengidentifikasi setiap penyelesaian penawaran dan pesanan penjualan hingga penagihan dan pembayarannya dilakukan.',
                    button: <Link
                        data-tip="This is a tooltip"
                        className="my-2"
                        to={`#`}>
                        Lihat Laporan
                    </Link>
                }
            ]);
        } else if (activeType == 'bussines') {
            setTabContent([
                {
                    title: 'Laporan Posisi Keuangan',
                    description: 'Menampilkan apa yang dimiliki (aset), apa saja utangnya (liabilitas), dan apa yang sudah diinvestasikan ke perusahaan ini (ekuitas) pada tanggal tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/balance-sheet`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Laba Rugi',
                    description: 'Menampilkan semua pendapatan yang diperoleh dan biaya yang dikeluarkan dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/profit-loss`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Arus Kas',
                    description: 'Menampilkan pergerakan uang masuk dan keluar dari transaksi dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/cashflow`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Perubahan Modal',
                    description: 'Menampilkan perubahan atau pergerakan ekuitas pemilik dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/statement-equity`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Anggaran Laba Rugi',
                    description: 'Menampilkan perbandingan antara jumlah transaksi sebenarnya dan anggaran yang telah disusun per akun.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/profit-loss-budget`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Buku Besar',
                    description: 'Menampilkan semua transaksi berdasarkan akun dalam periode tertentu, termasuk kronologi pergerakan transaksinya selama periode berlangsung.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/general-ledger`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Jurnal',
                    description: 'Menampilkan semua journal entry per transaksi dalam periode tertentu. Anda dapat melacak transaksi yang masuk ke masing-masing akun.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/journal`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Neraca Saldo',
                    description: 'Menampilkan saldo dari setiap akun, termasuk saldo awal, pergerakan, dan saldo akhir dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Ringkasan Bisnis',
                    description: 'Menampilkan ringkasan laporan keuangan utama dan wawasannya dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/executive-summary`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Manajemen Anggaran',
                    description: 'Memungkinkan Anda mengatur dan mengelola anggaran untuk pengeluaran dan pendapatan perusahaan ini.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/budget-management`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
            ]);            
        } else if (activeType == 'purchases') {
            setTabContent([
                {
                    title: 'Daftar Pembelian',
                    description: 'Menampilkan transaksi pembelian secara kronologis berdasarkan tipenya dalam periode tertentu. Template laporan ini bisa Anda custom sesuai kebutuhan.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/purchases`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Pembelian per Supplier',
                    description: 'Menampilkan semua transaksi pembelian dari setiap supplier dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Utang Supplier',
                    description: 'Menampilkan semua faktur yang belum dibayar dan saldo memo debit supplier pada tanggal tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`/activity-erpppsu/report/vendor-balance`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Daftar Pengeluaran',
                    description: 'Menampilkan semua transaksi pengeluaran dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Detail Pengeluaran',
                    description: 'Menampilkan semua transaksi pengeluaran berdasarkan akun dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Usia Utang',
                    description: 'Menampilkan total utang kepada setiap supplier berdasarkan usianya (30, 60, 90, dan setelah 90 hari).',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                // {
                //     title: 'Pengiriman Pembelian',
                //     description: 'Menampilkan semua produk yang dikirim untuk transaksi pembelian dalam periode tertentu.',
                //     button: (
                //         <Link
                //             data-tip="This is a tooltip"
                //             className="my-2"
                //             to={`#`}>
                //             Lihat Laporan
                //         </Link>
                //     ),
                // },
                {
                    title: 'Pembelian per Produk',
                    description: 'Menampilkan semua kuantitas produk yang dibeli, kuantitas retur, pembelian bersih, dan harga pembelian rata-rata dalam periode tertentu.',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                // {
                //     title: 'Penyelesaian Pesanan Pembelian',
                //     description: 'Menampilkan ringkasan proses bisnis perusahaan ini. Anda dapat mengidentifikasi setiap penyelesaian penawaran dan pesanan pembelian hingga penagihan dan pembayarannya dilakukan.',
                //     button: (
                //         <Link
                //             data-tip="This is a tooltip"
                //             className="my-2"
                //             to={`#`}>
                //             Lihat Laporan
                //         </Link>
                //     ),
                // },
            ]);            
        } else if (activeType == 'tax') {
            setTabContent([
                {
                    title: 'Pajak Pemotongan',
                    description: 'Menampilkan dasar pengenaan pajak (DPP), tarif pajak, dan jumlah pajak dengan tipe pemotongan yang digunakan di transaksi dalam periode tertentu',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                },
                {
                    title: 'Pajak Penjualan',
                    description: 'Menampilkan dasar pengenaan pajak (DPP), tarif pajak, dan jumlah pajak dengan pajak pertambahan nilai (PPN) yang digunakan di transaksi dalam periode tertentu',
                    button: (
                        <Link
                            data-tip="This is a tooltip"
                            className="my-2"
                            to={`#`}>
                            Lihat Laporan
                        </Link>
                    ),
                }
            ]);            
        }

    }, [activeType]);

    const handleTabClick = (tab) => {
        setActiveType(tab);
    };


    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1>Laporan</h1>

                <div className='flex items-center'>
                </div>
            </div>

            <div className="tabs">
                {tabHeader.map((tab) => (
                    <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
                        handleTabClick(tab.key)
                    }} />
                ))}
            </div>

            <div className='p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6'>
                {tabContent.map((content) => (
                    <div>
                        <h1>
                            {content.title}
                        </h1>
                        <p>
                            {content.description}
                        </p>
                        {content.button}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Report;
